export default __webpack_public_path__ + "static/media/david7.dcebd713.jpg";